/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import { DisplayKey } from '../../../Game/DisplayKey';
import { StateID } from '../../../StateManager/StateID';
import ComponentBase from '../../ComponentBase';
import OptionalBaseComponent from './OptionalBaseComponent';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

/** Removes visual components based on the configuration supplied by the RGS server. */
@cc._decorator.ccclass
export default class OptionalComponent extends OptionalBaseComponent
{
    /** Add optional component with Demo settings. */
    public static AddDemoOptionalComponent(
        node: cc.Node | cc.Component,
        stateId: StateID = StateID.CheckRecovery): OptionalComponent
    {
        const optionalComponent: OptionalComponent = ComponentBase.GetOrAddComponent(node, OptionalComponent);
        optionalComponent.DisplayKey = DisplayKey.Demo;
        optionalComponent.Destructive = true;
        optionalComponent.CheckOnStateId = stateId;
        return optionalComponent;
    }

    /** Whether or not the attached node should be destroyed or disabled. */
    @property({ visible: true })
    private _destructive: boolean = false;
    public set Destructive(value: boolean) { this._destructive = value; }

    /** @hidden */
    protected trigger(): void
    {
        if (this.isDisplayKeyValid()) { return; }

        this.node.active = false;
        if (this._destructive) { this.node.destroy(); }
    }
}
